module.exports = "https://assets.niwcorp.com/_next/static/images/ico-youtube-9b63e62961910d04113e9eef5a2c9b2f.svg";